"use client";

import { useTranslations } from "next-intl";
import { FC } from "react";

import RangeInput from "@/components/ui/RangeInput";

interface MileageInputProps {
  onFromMileageChange: (value: string) => void;
  onToMileageChange: (value: string) => void;
  onFromMileageClear: () => void;
  onToMileageClear: () => void;
  onReset: () => void;
  fromValue?: string | null;
  toValue?: string | null;
}

const MileageInput: FC<MileageInputProps> = ({
  onFromMileageChange,
  onToMileageChange,
  onFromMileageClear,
  onToMileageClear,
  onReset,
  fromValue,
  toValue,
}) => {
  const t = useTranslations("Filters");

  return (
    <RangeInput
      label={t("mileage")}
      onFromChange={onFromMileageChange}
      onToChange={onToMileageChange}
      onFromClear={onFromMileageClear}
      onToClear={onToMileageClear}
      onReset={onReset}
      fromValue={fromValue}
      toValue={toValue}
    />
  );
};

export default MileageInput;
